import React from 'react';
import Banner from "../../../../../assets/images/BreachRisk_Attestations.svg";
import BRValidationTable
    from "../../../../../components/customBreachBits/BreachRiskValidationProviding/BRValidationTable";
import {HashLink as Link} from "react-router-hash-link";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";
import {bbDoesUserHaveAccessToBreachRiskLevelForEntity, isCurrentUserMemberOf} from "../../../../../util/bbHelpers";
import {useSelector} from "react-redux";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";

const AttestationsPage = ({
                              portfolioView = false
                          }) => {
    const {authUser} = useSelector(({auth}) => auth);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);

    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);
    const isAdministratorForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView);

    return(
        <div className="app-wrapper">
            <div className="animated fadeIn animation-duration-7">
                <div className="row">
                    <div className={"col-8 align-self-center"}>
                        <div className={"mx-0 px-0"}>
                            <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                        </div>
                    </div>
                    <div className={"col-4 align-self-center"}>
                        <h3>Attestation increases confidence.</h3>
                        <p>When others view your BreachRisk™ Score and BreachRisk™ Report, give them the confidence of your promise. Cyberspace is a big place, so when you provide
                        attestations it also increases the fidelity of your BreachRisk™ Score.</p>

                    </div>
                </div>
                <hr/>
                {(portfolioView && (isStaffAdmin || isAdministratorForThisEntity)) || !portfolioView
                    ?<VerifiedOwnershipRequiredDialog>

                <h1>Attestation</h1>
                <p>Attest that the IP Addresses, Domains, and Subdomains that appear in your <Link smooth to={{pathname: "/board/BreachRisk/Business/Verifications"}}>Verification page</Link> fully describe your IT infrastructure accessible from the public internet. You should strive to make an attestation at least every 90 days.</p>

                <div className="row">

                    <div className="col-12" id={"tourAttestationsTable"}>
                        <BRValidationTable portfolioView={portfolioView}/>

                    </div>
                </div>
                </VerifiedOwnershipRequiredDialog>
                    : <>
                        <br/>
                        <br/>
                        <br/>
                        <Tooltip title={"If you need these details, this company will need to approve a request."} link={`https://support.breachbits.com/knowledge/requesting-access`}>
                            <h2 className={"text-center"}>You don't have Administrator privileges for this Entity <InfoSharpIcon/></h2>
                        </Tooltip>

                        <br/>
                        <br/>

                    </>}
            </div>
        </div>
        )
        };

export default AttestationsPage;